// extracted by mini-css-extract-plugin
module.exports = {"micHeight":"SearchBox_micHeight__drl9C"};